
import React from 'react';

interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  width?: number;
  height?: number;
}

export const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  className = '',
  objectFit = 'cover',
  width,
  height
}) => {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{
        objectFit,
        width: width ? `${width}px` : undefined,
        height: height ? `${height}px` : undefined
      }}
      loading="lazy"
    />
  );
};
